import styled, { css } from 'styled-components'

export const Floating = styled.div<{ horizontalOffset: number }>`
  position: absolute;
  top: -10px;
  left: 50%;

  ${({ horizontalOffset }) =>
    css`
      transform: translate(calc(-50% + ${horizontalOffset}px), -100%);
    `}

  color: #f9f9f9;
  font-size: 0.75rem;
  font-weight: 500;

  background: #2c2c2c;

  border-radius: 4px;

  padding: 12px 13px;

  opacity: 0;
  pointer-events: none;

  transition: opacity 0.3s ease;

  width: max-content;
`

export const Container = styled.div`
  position: relative;

  display: inline-block;

  width: 20px;
  height: 20px;

  &:hover {
    ${Floating} {
      opacity: 1;
      pointer-events: all;
    }
  }
`
